/**
 * USPATIH GO — Bersihkan state klien per-user saat logout / ganti akun.
 * Mencegah data user sebelumnya tampil setelah login user lain.
 */

const AUTH_KEYS = ['uspatih_user', 'uspatih_token'];
const LEGACY_KEYS = ['cart_count', 'kasir_opening_cash'];
const SESSION_KEYS = ['uspatih_pending_order', 'framio_draft', 'framio_publish_intent'];

/** Prefix localStorage yang perlu dihapus (cart_count:123, kasir_opening_cash:456, dll.) */
const PREFIXES = ['cart_count:', 'kasir_opening_cash:', 'uspatih_'];

/**
 * @param {{ keepTheme?: boolean }} opts
 */
export function clearUserClientState(opts = {}) {
  const { keepTheme = true } = opts;

  const themeKeys = keepTheme
    ? new Set(['theme', 'uspatih_theme', 'color-scheme'])
    : new Set();

  AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
  LEGACY_KEYS.forEach((k) => localStorage.removeItem(k));

  const toRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key || themeKeys.has(key)) continue;
    if (PREFIXES.some((p) => key.startsWith(p))) {
      toRemove.push(key);
    }
  }
  toRemove.forEach((k) => localStorage.removeItem(k));

  SESSION_KEYS.forEach((k) => {
    try { sessionStorage.removeItem(k); } catch { /* ignore */ }
  });

  resetAlpineStores();
}

export function resetAlpineStores() {
  if (typeof window.Alpine === 'undefined') return;

  try {
    const cart = window.Alpine.store('cart');
    if (cart) {
      cart.count = 0;
      cart.items = [];
    }
  } catch { /* ignore */ }

  try {
    const notif = window.Alpine.store('notifications');
    if (notif) {
      notif.unread = 0;
      notif.items = [];
      notif.loading = false;
      notif.open = false;
    }
  } catch { /* ignore */ }
}

/** Panel kasir/admin/creator — jangan kirim Bearer token customer */
export function isPanelPath(path = window.location?.pathname || '') {
  if (!path) return false;
  const panelPrefix = document.querySelector('meta[name="panel-url-prefix"]')?.content;
  if (panelPrefix && path.startsWith(panelPrefix)) return true;
  if (path.includes('/ops/')) return true;
  if (path.includes('/sys/admin')) return true;
  const creatorPrefix = document.querySelector('meta[name="creator-url-prefix"]')?.content;
  if (creatorPrefix && path.startsWith(creatorPrefix)) return true;
  if (path.startsWith('/studio')) return true;
  return false;
}

/** Panel session atau token customer dashboard */
export function isPanelOrCustomerAuth() {
  if (isPanelPath()) return true;
  try {
    return !!window.Alpine?.store('auth')?.isLoggedIn;
  } catch {
    return false;
  }
}

/** Hard refresh agar tidak pakai bfcache (history login sebelumnya) */
export function hardNavigate(url) {
  window.location.replace(url);
}

if (typeof window !== 'undefined') {
  window.__uspClearClientSession = clearUserClientState;
}
